import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  background-color: #ffffff;
  padding: 40px 16px 30px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CloseIconContainer = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;

  svg {
    transition: opacity 300ms ease-in-out;

    &:hover {
      opacity: 0.75;
    }
  }
`;
